import React, { Component } from "react";
import {
  Button,
  Container,
  Segment,
  Menu
} from "semantic-ui-react";
import { Route, Link } from 'react-router-dom';

import AppContainer from './AppContainer';
import Firebase from './Firebase';

import AdminDashboard from './AdminDashboard';
import AdminBook from './AdminBook';


const style = {
  mainContainer: {
    marginTop: "3em",
    marginBottom: "3em",
    paddingTop: "3em",
    paddingBottom: "3em"
  }
};


export default class AdminAuth extends Component {
  constructor(props){
      super(props);
      this.state = {
        user: null,
        token: null,
        errorMsg: null
      }
  }

  componentDidMount(){
    Firebase.getFirebase().auth().onAuthStateChanged((user) => {
      this.setState({user: user});
    });
  }

  onSignin(){
    var firebase = Firebase.getFirebase();
    var provider = new firebase.auth.GoogleAuthProvider()
    firebase.auth().signInWithRedirect(provider);
  }

  onSignout(){
    Firebase.getFirebase().auth().signOut();
  }

  render() {
    return (
      <AppContainer>
        <Container>
          <Segment style={style.mainContainer}>
            <Container text>
              <Menu>
                <Menu.Item>
                  Admin
                </Menu.Item>
                { !this.state.user ?
                  <Menu.Item>
                    <Button primary onClick={this.onSignin}>
                      Sign in
                    </Button>
                  </Menu.Item> :
                  <React.Fragment>
                    <Link to="/admin">
                      <Menu.Item>
                        <Button positive>
                          Dashboard
                        </Button>
                      </Menu.Item>
                    </Link>
                    <Menu.Item>
                      { "Welcome, " + this.state.user.email}
                    </Menu.Item>
                    <Menu.Item>
                      <Button primary onClick={this.onSignout}>
                        Sign out
                      </Button>
                    </Menu.Item>
                  </React.Fragment>
                }
              </Menu>
              { this.state.user ?
                <div>
                  <Route path="/admin/" exact component={AdminDashboard} />
                  <Route path="/admin/book/:id" component={AdminBook} />
                </div> : ""
              }
            </Container>
          </Segment>
        </Container>
      </AppContainer>
    );
  }
}
